<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Gestión de Accesos</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Gestión de Accesos</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.idCompania" [disabled]="listaCompanias.length == 1" (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> 
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.sedes" name="sedes" multiple>
                <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Trabajador:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Nombres y Apellidos </mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nombreEmpleado" name="nombreEmpleado"
                maxlength="40" />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Nro Documento Identidad:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Nro Documento Identidad</mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nroDocumento" name="nroDocumento" maxlength="15"
                (keypress)="keyPressNumberOnly($event)" />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-2 control-label">Código Solicitud:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Código Solicitud </mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.codigoSolicitud" name="codigoSolicitud"
                maxlength="10" />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Fecha Fin de Trabajo:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Fecha de Servicio</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Desde" [(ngModel)]="modelFilter.fechaInicioServicio" />
                <input matEndDate placeholder="Hasta" [(ngModel)]="modelFilter.fechaFinServicio" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-2 control-label">Empresa:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Empresa </mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nombreContratista" name="nombreContratista"
                maxlength="40" />
            </mat-form-field>
          </div>
          
        </div>
      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="form-horizontal">
        <mat-divider class="engie-divider"></mat-divider>
      </div>
      <mat-tab-group #tabGroup>
        <mat-tab label="Bloquear">
          <div class="block-content">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-left">

                  <a class="btn btn-rojo" mat-raised-button (click)="deshabilitar()"
                    [disabled]="esInvalido()"><mat-icon>cancel</mat-icon> Bloquear Accesos</a>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="modelListaAccesoPersonal" class="table table-striped table-vcenter">
                <ng-container matColumnDef="codigo">
                  <th mat-header-cell *matHeaderCellDef>Codigo</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.codigoSolicitud }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="compania">
                  <th mat-header-cell *matHeaderCellDef>Compañía</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
                </ng-container>

                <ng-container matColumnDef="sede">
                  <th mat-header-cell *matHeaderCellDef>Sede</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.sede }}</td>
                </ng-container>

                <ng-container matColumnDef="trabajador">
                  <th mat-header-cell *matHeaderCellDef>Trabajador</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.nombres }} {{ element.apellidoPaterno }}
                    {{ element.apellidoMaterno }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="nroDocumentoIdentidad">
                  <th mat-header-cell *matHeaderCellDef># Documento Identidad</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.nroDocumentoIdentidad }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="contratista">
                  <th mat-header-cell *matHeaderCellDef>Empresa</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.contratista }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="fechaAprobacion">
                  <th mat-header-cell *matHeaderCellDef>Fecha Aprobación</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fechaAprobacion | date: "dd/MM/yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="estado">
                  <th mat-header-cell *matHeaderCellDef>Estado</th>
                  <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
                </ng-container>

                <ng-container matColumnDef="fechaInicio">
                  <th mat-header-cell *matHeaderCellDef>Fecha Inicio</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fechaInicio | date: "dd/MM/yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="fechaFin">
                  <th mat-header-cell *matHeaderCellDef>Fecha Fin</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fechaFin | date: "dd/MM/yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [(ngModel)]="element.deshabilitar"></mat-checkbox>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
              <mat-paginator #paginator [length]="resultsLength" [pageSize]="modelFilter.pageSize" (page)="getPaginatorData($event)"
                [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Restablecer">
          <div class="block-content">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-left">

                  <a class="btn btn-naranja" mat-raised-button (click)="reestablecer()"
                    [disabled]="esInvalidoReestablecer()"><mat-icon>verified_user</mat-icon> Restablecer Accesos</a>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="modelListaReestablecerAcceso" class="table table-striped table-vcenter">
                <ng-container matColumnDef="codigo">
                  <th mat-header-cell *matHeaderCellDef>Codigo</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.codigoSolicitud }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="compania">
                  <th mat-header-cell *matHeaderCellDef>Compañía</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
                </ng-container>

                <ng-container matColumnDef="sede">
                  <th mat-header-cell *matHeaderCellDef>Sede</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.sede }}</td>
                </ng-container>

                <ng-container matColumnDef="trabajador">
                  <th mat-header-cell *matHeaderCellDef>Trabajador</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.nombres }} {{ element.apellidoPaterno }}
                    {{ element.apellidoMaterno }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="nroDocumentoIdentidad">
                  <th mat-header-cell *matHeaderCellDef># Documento Identidad</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.nroDocumentoIdentidad }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="contratista">
                  <th mat-header-cell *matHeaderCellDef>Empresa</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.contratista }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="fechaAprobacion">
                  <th mat-header-cell *matHeaderCellDef>Fecha Aprobación</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fechaAprobacion | date: "dd/MM/yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="estado">
                  <th mat-header-cell *matHeaderCellDef>Estado</th>
                  <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
                </ng-container>

                <ng-container matColumnDef="fechaInicio">
                  <th mat-header-cell *matHeaderCellDef>Fecha Inicio</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fechaInicio | date: "dd/MM/yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="fechaFin">
                  <th mat-header-cell *matHeaderCellDef>Fecha Fin</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.fechaFin | date: "dd/MM/yyyy" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [(ngModel)]="element.deshabilitar"></mat-checkbox>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
              <mat-paginator #paginatorReestablecer [length]="resultsReestablecerLength" [pageSize]="modelFilter.pageSize" (page)="getPaginatorReestablecerData($event)"
                [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>

    </div>
  </div>
</div>